import { render, staticRenderFns } from "./etablissement-detail.vue?vue&type=template&id=0e8afdcb&scoped=true"
import script from "./etablissement-detail.vue?vue&type=script&lang=js"
export * from "./etablissement-detail.vue?vue&type=script&lang=js"
import style0 from "./etablissement-detail.vue?vue&type=style&index=0&id=0e8afdcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8afdcb",
  null
  
)

export default component.exports